import api from './axiosInstance';

export const getUserProfile = () => api.get('/auth/me');
export const updateUserProfile = (data) => api.patch('/auth/profile', data);
export const changeUserPassword = (data) => api.patch('/auth/change-password', data);
